module.exports = __webpack_public_path__ + "static/media/arrow-back.ce1546bb.svg";